export const AddFavorite = () => {
  return <button></button>;
};
